module.exports = __webpack_public_path__ + "0e896c4d16f117db1b2aa6015e3f2fce.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@webapp/preact-shared/img/icon-alert-yellow@2x.png
// module id = 277
// module chunks = 7